import { useState, useEffect } from 'react';
import styles from './PriceUpdateBanner.module.css';

export default function PriceUpdateBanner() {
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        document.documentElement.style.setProperty('--pu-banner-h', dismissed ? '0px' : '56px');
        return () => document.documentElement.style.removeProperty('--pu-banner-h');
    }, [dismissed]);

    if (dismissed) return null;

    return (
        <div className={styles.banner} role="region" aria-label="Pricing announcement">
            <div className={styles.inner}>
                <span className={styles.tag}>
                    <span className={styles.tagDot} aria-hidden="true"></span>
                    New pricing!
                </span>

                <div className={styles.copy}>
                    <span>Our same clinician-guided GLP-1 care, now more accessible.</span>
                    <a href="/programs" className={styles.price} aria-label="See updated plans, starting at $124 per month after your first month free">
                        <span className={styles.priceSmall}>Starting at</span>
                        <span className={styles.priceAmount}>$124</span>
                        <span className={styles.priceSmall}>/MO</span>
                    </a>
                </div>

                <a href="/programs" className={styles.cta} aria-label="See updated plans">
                    <span className={styles.ctaLabel}>See plans</span>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <line x1="5" y1="12" x2="19" y2="12"/>
                        <polyline points="13 6 19 12 13 18"/>
                    </svg>
                </a>

                <button className={styles.close} type="button" aria-label="Dismiss pricing announcement" onClick={() => setDismissed(true)}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <line x1="6" y1="6" x2="18" y2="18"/>
                        <line x1="18" y1="6" x2="6" y2="18"/>
                    </svg>
                </button>
            </div>
        </div>
    );
}
